export const shortCodeLength = 6
export const generateShortCode = () => {
  return Math.random()
    .toString(36)
    .substring(shortCodeLength + 1)
}
